class NoId {
  copyWith(additionalDebugParts) {
    return this;
  }
  toString() {
    return void 0;
  }
  toHtmlId() {
    return void 0;
  }
}
class NormalId {
  constructor(id) {
    this.id = id;
  }
  copyWith(additionalDebugParts) {
    return new NoId();
  }
  toString() {
    const currentId = this.id;
    this.id = "";
    return currentId;
  }
  toHtmlId() {
    return void 0;
  }
}
class DebugId {
  constructor(parentComponentIdParts, currentComponentDebugParts) {
    this.idParts = parentComponentIdParts;
    if (currentComponentDebugParts) {
      currentComponentDebugParts.forEach((part) => {
        this.idParts.push(part);
      });
    }
  }
  copyWith(additionalDebugParts) {
    const clone = new DebugId(JSON.parse(JSON.stringify(this.idParts)));
    additionalDebugParts.forEach((part) => {
      clone.idParts.push(part);
    });
    return clone;
  }
  toString() {
    return this.partsToDisplayableId();
  }
  toHtmlId() {
    return this.idParts;
  }
  partsToDisplayableId() {
    return this.idParts.reduce((previousValue, currentValue) => {
      if (previousValue && currentValue) {
        return `${previousValue}-${Id.toCamelCaseIdFormat(currentValue)}`;
      } else if (currentValue) {
        return Id.toCamelCaseIdFormat(Id.beginWithLetter(currentValue));
      }
      return previousValue;
    }, "");
  }
}
class Id {
  constructor() {
    this.id = void 0;
  }
  static create(htmlIdFromParent, currentComponentDebugParts) {
    const wrapped = new Id();
    if (htmlIdFromParent !== void 0) {
      const clone = JSON.parse(JSON.stringify(htmlIdFromParent));
      if (typeof clone === "string") {
        wrapped.id = new NormalId(clone);
      } else if (clone !== void 0 && clone.constructor === Array) {
        wrapped.id = new DebugId(clone, currentComponentDebugParts);
      }
    } else {
      wrapped.id = new NoId();
    }
    return wrapped;
  }
  copyWith(additionalDebugParts) {
    return this.id ? this.id.copyWith(additionalDebugParts) : new NoId();
  }
  toString() {
    return this.id ? this.id.toString() : void 0;
  }
  toHtmlId() {
    return this.id ? this.id.toHtmlId() : void 0;
  }
  static toCamelCaseIdFormat(text) {
    return text.split(" ").reduce((previousValue, currentValue) => {
      const val = currentValue.replace(/[\W_]/g, "");
      if (previousValue) {
        return previousValue + this.capitalizeFirstLetter(val);
      }
      return val.toLowerCase();
    }, "");
  }
  static capitalizeFirstLetter(str) {
    let result = "";
    if (str.length > 0) {
      result += str.charAt(0).toUpperCase();
    }
    if (str.length > 1) {
      result += str.slice(1).toLowerCase();
    }
    return result;
  }
  static beginWithLetter(text) {
    const res = text.match(/[a-zA-Z]+.*/g);
    if (res && res.length > 0) {
      return res[0];
    }
    return "";
  }
}
let idCounter = 0;
const uniqueId = (prefix) => {
  return Id.create([prefix, (idCounter++).toString()]).toString();
};

export { DebugId, Id, NoId, NormalId, uniqueId };
